import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(props.width || 182)}
    height={(props.width|| 182)}
    viewBox="0 0 182 182"
    fill="none"
    {...props}
  >
    <path
      stroke="url(#aka)"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m1.357 1 179.288 179.998"
    />
    <defs>
      <linearGradient
        id="aka"
        x1={0.998}
        x2={180.752}
        y1={1}
        y2={180.895}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.095} stopColor="#fff" stopOpacity={0.5} />
        <stop offset={0.24} stopColor="#fff" />
        <stop offset={0.475} stopColor="#fff" stopOpacity={0.5} />
        <stop offset={0.62} stopColor="#fff" stopOpacity={0.5} />
        <stop offset={0.86} stopColor="#fff" stopOpacity={0.2} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.2} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
